import axiosAPI from '@/api/axios'

export default {
  async fetchPingtree(params) {
    return await axiosAPI.get('/api/pingtree', {
      params: params,
    })
  },

  async fetchPartners() {
    return await axiosAPI.get('/api/pingtree/partners')
  },

  async savePingtree(payload) {
    return await axiosAPI.post('/api/pingtree', payload)
  },

  async syncPingtree(payload) {
    return await axiosAPI.post('/api/pingtree/sync', payload)
  },
}
